import PropTypes from 'prop-types';
import React from 'react';

import localize from 'components/Localize/Localize';
import PropQuote from 'components/PropQuote/PropQuote';
import { ResponsiveImage } from 'sheets';

import styles from './ProductLifestyle.css';

import translations from './translations';

class Lifestyle extends React.Component {
  render() {
    return (
      <section className={styles[`container`]}>
        <div role="presentation">
          <ResponsiveImage
            config={this.props.imageConfig}
            description={this.props.t.imageAlt}
          />
        </div>
        <div className={styles[`content`]}>
          <PropQuote
            icon={this.props.t.images.logo}
            quote={this.props.t.quote}
          />
        </div>
      </section>
    );
  }
}

Lifestyle.propTypes = {
  imageConfig: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  t: PropTypes.shape({
    imageAlt: PropTypes.string.isRequired,
    images: PropTypes.object.isRequired,
    quote: PropTypes.string.isRequired,
  }).isRequired,
};

export default localize(Lifestyle, translations);
